<template>
  <div v-show="isShowAnnouncement" class="announcement">
    <div class="content">
      <div></div>
      <div class="a_c_text">{{ announcementData.content }}</div>
      <img alt="logo" src="../../assets/announcement/icon_announcement_close.svg" @click="handleClickCloseAnnouncement">
    </div>
  </div>
</template>

<script>

import {getAnnouncementListData} from '@/api/swap'

export default {

  data() {
    return {
      isEnglish: false,
      isShowAnnouncement: false,
      announcementData: '',
    }
  },
  // watch/event事件回调
  created() {
    this.isEnglish = sessionStorage.getItem("lang") !== "zh";
    this.getAnnouncementData();
  },
  mounted() {
    let routeName = this.$route.name;
    this.isShowAnnouncement = true;
    this.getAnnouncementData();
    // if (routeName === 'home') {
    //   this.isShowAnnouncement = true;
    //   this.getAnnouncementData();
    // } else {
    //   this.isShowAnnouncement = false;
    // }
  },
  destroyed() {

  },
  computed: {},
  // 监听方法
  watch: {
    // 监听路由变化
    $route(to, from) {
      // let routeName = to.name;
      // this.isShowAnnouncement = true;
      // this.isShowAnnouncement = routeName === 'home';
      // console.log('router change name =', routeName);
    },
    // 监听语言的切换
    '$i18n.locale'(val, oval) {
      this.isEnglish = val !== 'zh';
      this.getAnnouncementData();
      console.log('监听语言发生变化');
    },
  },
  // 方法集合
  methods: {
    handleClickCloseAnnouncement() {
      this.isShowAnnouncement = false;
    },
    // 获取公告
    async getAnnouncementData() {
      const dict = {};
      // dict['language'] = this.isEnglish ? 'en' : 'ch';
      const result = await getAnnouncementListData(dict);
      if (result.notices.length > 0) {
        this.announcementData = this.isEnglish ? result.notices[0].en : result.notices[0].ch;
        //console.log('公告列表数据=', this.announcementData);
      } else {
        // this.$notify({ message: '暂无公告' });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.announcement {
  width: 100vw;
  height: 50px;
  box-sizing: border-box;
  background: linear-gradient(to right, #72e2ac 1%, #73c0e8 48%, #c99dff 101%);
  .content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .a_c_text {
      font-family: PingFangHK;
      font-size: 20px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: var(--white);
      user-select: none;
    }
    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 960px) {
  .announcement {
    width: 100vw;
    height: vw(100);
    .content {
      width: 100vw;
      padding: 0 vw(30);
      .a_c_text {
        font-size: vw(20);
      }
      img {
        width: vw(40);
        height: vw(40);
      }
    }
  }
}
</style>